// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**/
:root {
    --main-color: #eaeaea;
    --stroke-color: black;
    
  }
  /**/
  .error-page body {
    background: var(--main-color);
  }
  .error-page h1 {
    margin: 100px auto 0 auto;
    color: var(--stroke-color);
    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;
    font-size: 10rem; line-height: 10rem;
    font-weight: 200;
    text-align: center;
  }
  .error-page h2 {
    margin: 20px auto 30px auto;
    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;
    font-size: 1.5rem;
    font-weight: 200;
    text-align: center;
  }
  .error-page h1, .error-page h2 { /* Safari */
    transition: opacity 0.5s linear, margin-top 0.5s linear;
  }
  .loading h1, .loading h2 {
    margin-top: 0px;
    opacity: 0;  
  }
  .gears {
    position: relative;
    margin: 0 auto;
    width: auto; height: 0;
  }
  .gear {
    position: relative;
    z-index: 0;
    width: 120px; height: 120px;
    margin: 0 auto;
    border-radius: 50%;
    background: var(--stroke-color);
  }
  .gear:before{
    position: absolute; left: 5px; top: 5px; right: 5px; bottom: 5px;
    z-index: 2;
    content: "";
    border-radius: 50%;
    background: var(--main-color);
  }
  .gear:after {
    position: absolute; left: 25px; top: 25px;
    z-index: 3;
    content: "";
    width: 70px; height: 70px;
    border-radius: 50%;
    border: 5px solid var(--stroke-color);
    box-sizing: border-box;
    background: var(--main-color);
  }
  .gear.one {
    left: -130px;
  }
  .gear.two {
    top: -75px;
  }
  .gear.three {
    top: -235px;
    left: 130px;
  }
  .gear .bar {
    position: absolute; left: -15px; top: 50%;
    z-index: 0;
    width: 150px; height: 30px;
    margin-top: -15px;
    border-radius: 5px;
    background: var(--stroke-color);
  }
  .gear .bar:before {
    position: absolute; left: 5px; top: 5px; right: 5px; bottom: 5px;
    z-index: 1;
    content: "";
    border-radius: 2px;
    background: var(--main-color);
  }
  .gear .bar:nth-child(2) {
    transform: rotate(60deg);
    -webkit-transform: rotate(60deg);
  }
  .gear .bar:nth-child(3) {
    transform: rotate(120deg);
    -webkit-transform: rotate(120deg);
  }
  .gear.one {
    -webkit-animation: anticlockwiseErrorStop 2s linear infinite;
  }
  .gear.two {
    -webkit-animation: anticlockwiseError 2s linear infinite;
  }
  .gear.three {
    -webkit-animation: clockwiseError 2s linear infinite;
  }
  .loading .gear.one, .loading .gear.three {
    -webkit-animation: clockwise 3s linear infinite;
  }
  .loading .gear.two {
    -webkit-animation: anticlockwise 3s linear infinite;
  }`, "",{"version":3,"sources":["webpack://./src/components/error_page/error_page.css"],"names":[],"mappings":"AAAA,GAAG;AACH;IACI,qBAAqB;IACrB,qBAAqB;;EAEvB;EACA,GAAG;EACH;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,8DAA8D;IAC9D,gBAAgB,EAAE,kBAAkB;IACpC,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,8DAA8D;IAC9D,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA,iCACmE,WAAW;IAC5E,uDAAuD;EACzD;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW,EAAE,SAAS;EACxB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,aAAa;IAC3B,cAAc;IACd,kBAAkB;IAClB,+BAA+B;EACjC;EACA;IACE,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,UAAU,EAAE,WAAW;IAChE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,kBAAkB,EAAE,UAAU,EAAE,SAAS;IACzC,UAAU;IACV,WAAW;IACX,WAAW,EAAE,YAAY;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,kBAAkB,EAAE,WAAW,EAAE,QAAQ;IACzC,UAAU;IACV,YAAY,EAAE,YAAY;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;EACjC;EACA;IACE,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,UAAU,EAAE,WAAW;IAChE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,wBAAwB;IACxB,gCAAgC;EAClC;EACA;IACE,yBAAyB;IACzB,iCAAiC;EACnC;EA6BA;IACE,4DAA4D;EAC9D;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,oDAAoD;EACtD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,mDAAmD;EACrD","sourcesContent":["/**/\r\n:root {\r\n    --main-color: #eaeaea;\r\n    --stroke-color: black;\r\n    \r\n  }\r\n  /**/\r\n  .error-page body {\r\n    background: var(--main-color);\r\n  }\r\n  .error-page h1 {\r\n    margin: 100px auto 0 auto;\r\n    color: var(--stroke-color);\r\n    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;\r\n    font-size: 10rem; line-height: 10rem;\r\n    font-weight: 200;\r\n    text-align: center;\r\n  }\r\n  .error-page h2 {\r\n    margin: 20px auto 30px auto;\r\n    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;\r\n    font-size: 1.5rem;\r\n    font-weight: 200;\r\n    text-align: center;\r\n  }\r\n  .error-page h1, .error-page h2 {\r\n    -webkit-transition: opacity 0.5s linear, margin-top 0.5s linear; /* Safari */\r\n    transition: opacity 0.5s linear, margin-top 0.5s linear;\r\n  }\r\n  .loading h1, .loading h2 {\r\n    margin-top: 0px;\r\n    opacity: 0;  \r\n  }\r\n  .gears {\r\n    position: relative;\r\n    margin: 0 auto;\r\n    width: auto; height: 0;\r\n  }\r\n  .gear {\r\n    position: relative;\r\n    z-index: 0;\r\n    width: 120px; height: 120px;\r\n    margin: 0 auto;\r\n    border-radius: 50%;\r\n    background: var(--stroke-color);\r\n  }\r\n  .gear:before{\r\n    position: absolute; left: 5px; top: 5px; right: 5px; bottom: 5px;\r\n    z-index: 2;\r\n    content: \"\";\r\n    border-radius: 50%;\r\n    background: var(--main-color);\r\n  }\r\n  .gear:after {\r\n    position: absolute; left: 25px; top: 25px;\r\n    z-index: 3;\r\n    content: \"\";\r\n    width: 70px; height: 70px;\r\n    border-radius: 50%;\r\n    border: 5px solid var(--stroke-color);\r\n    box-sizing: border-box;\r\n    background: var(--main-color);\r\n  }\r\n  .gear.one {\r\n    left: -130px;\r\n  }\r\n  .gear.two {\r\n    top: -75px;\r\n  }\r\n  .gear.three {\r\n    top: -235px;\r\n    left: 130px;\r\n  }\r\n  .gear .bar {\r\n    position: absolute; left: -15px; top: 50%;\r\n    z-index: 0;\r\n    width: 150px; height: 30px;\r\n    margin-top: -15px;\r\n    border-radius: 5px;\r\n    background: var(--stroke-color);\r\n  }\r\n  .gear .bar:before {\r\n    position: absolute; left: 5px; top: 5px; right: 5px; bottom: 5px;\r\n    z-index: 1;\r\n    content: \"\";\r\n    border-radius: 2px;\r\n    background: var(--main-color);\r\n  }\r\n  .gear .bar:nth-child(2) {\r\n    transform: rotate(60deg);\r\n    -webkit-transform: rotate(60deg);\r\n  }\r\n  .gear .bar:nth-child(3) {\r\n    transform: rotate(120deg);\r\n    -webkit-transform: rotate(120deg);\r\n  }\r\n  @-webkit-keyframes clockwise {\r\n    0% { -webkit-transform: rotate(0deg);}\r\n    100% { -webkit-transform: rotate(360deg);}\r\n  }\r\n  @-webkit-keyframes anticlockwise {\r\n    0% { -webkit-transform: rotate(360deg);}\r\n    100% { -webkit-transform: rotate(0deg);}\r\n  }\r\n  @-webkit-keyframes clockwiseError {\r\n    0% { -webkit-transform: rotate(0deg);}\r\n    20% { -webkit-transform: rotate(30deg);}\r\n    40% { -webkit-transform: rotate(25deg);}\r\n    60% { -webkit-transform: rotate(30deg);}\r\n    100% { -webkit-transform: rotate(0deg);}\r\n  }\r\n  @-webkit-keyframes anticlockwiseErrorStop {\r\n    0% { -webkit-transform: rotate(0deg);}\r\n    20% { -webkit-transform: rotate(-30deg);}\r\n    60% { -webkit-transform: rotate(-30deg);}\r\n    100% { -webkit-transform: rotate(0deg);}\r\n  }\r\n  @-webkit-keyframes anticlockwiseError {\r\n    0% { -webkit-transform: rotate(0deg);}\r\n    20% { -webkit-transform: rotate(-30deg);}\r\n    40% { -webkit-transform: rotate(-25deg);}\r\n    60% { -webkit-transform: rotate(-30deg);}\r\n    100% { -webkit-transform: rotate(0deg);}\r\n  }\r\n  .gear.one {\r\n    -webkit-animation: anticlockwiseErrorStop 2s linear infinite;\r\n  }\r\n  .gear.two {\r\n    -webkit-animation: anticlockwiseError 2s linear infinite;\r\n  }\r\n  .gear.three {\r\n    -webkit-animation: clockwiseError 2s linear infinite;\r\n  }\r\n  .loading .gear.one, .loading .gear.three {\r\n    -webkit-animation: clockwise 3s linear infinite;\r\n  }\r\n  .loading .gear.two {\r\n    -webkit-animation: anticlockwise 3s linear infinite;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
